import { TextField, InputAdornment, Typography } from "@mui/material";
import { getBlankUnitMeta, joinBlankUnitValue, stripBlankUnitDisplay } from "../../../utils/fillQuestionUtils";
import { sanitizeTypedAnswerWithGivenUnit } from "../../../utils/answerMatchUtils";

/**
 * Multi-fill / table / fill-in-the-blank TextField with the same £ / % unit chip
 * pattern as short-answer TypeDrawInput (unit shown as adornment, joined into stored value).
 */
export default function FillBlankUnitTextField({
  question,
  blankIdx,
  value,
  onChange,
  onFocus,
  inputRef,
  sx,
  placeholder,
  size = "small",
  inputProps,
  ...rest
}) {
  const unitMeta = getBlankUnitMeta(question, blankIdx);
  const displayValue = stripBlankUnitDisplay(value, unitMeta);

  const handleChange = (next) => {
    const cleaned = unitMeta?.unit
      ? sanitizeTypedAnswerWithGivenUnit(next, unitMeta.unit, { isPrefix: !!unitMeta.prefix })
      : next;
    onChange?.(joinBlankUnitValue(cleaned, unitMeta));
  };

  return (
    <TextField
      size={size}
      placeholder={placeholder}
      value={displayValue}
      onChange={(e) => handleChange(e.target.value)}
      onFocus={onFocus}
      inputRef={inputRef}
      sx={sx}
      inputProps={inputProps}
      InputProps={{
        ...(unitMeta.prefix
          ? {
              startAdornment: (
                <InputAdornment position="start">
                  <Typography sx={{ fontWeight: 700, fontSize: "1rem", color: "text.primary", userSelect: "none" }}>
                    {unitMeta.unit}
                  </Typography>
                </InputAdornment>
              ),
            }
          : {}),
        ...(unitMeta.unit && !unitMeta.prefix
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <Typography sx={{ fontWeight: 700, fontSize: "1rem", color: "text.primary", userSelect: "none" }}>
                    {unitMeta.unit}
                  </Typography>
                </InputAdornment>
              ),
            }
          : {}),
      }}
      {...rest}
    />
  );
}

/** Display/value helpers for MathInputTools wired to a unit-aware blank. */
export function blankMathToolsAdapters(question, blankIdx, storedValue, onChange) {
  const unitMeta = getBlankUnitMeta(question, blankIdx);
  return {
    getValue: () => stripBlankUnitDisplay(storedValue, unitMeta),
    onChange: (next) => {
      const cleaned = unitMeta?.unit
        ? sanitizeTypedAnswerWithGivenUnit(next, unitMeta.unit, { isPrefix: !!unitMeta.prefix })
        : next;
      onChange?.(joinBlankUnitValue(cleaned, unitMeta));
    },
  };
}
